// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__25a18","content":"Consent_content__1tLVf","footer":"Consent_footer__zeKso"};